<template>
    <v-app id="visitor">
        <v-main>
            <transition name="fade">
                <router-view></router-view>
            </transition>
            <v-bottom-sheet v-model="error">
                <v-sheet class="text-center" height="200px">
                    <div class="py-3 text-danger">{{errorMessage}}</div>
                    <v-btn @click="closeHandler" color="primary">ok</v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </v-main>
    </v-app>
</template>

<script>

    export default {
        data() {
            return {
                ajaxError: null,
                error: null,
                errorMessage: null,
                redirect: null,
            };
        },
        methods: {
            closeHandler() {
                this.error = false;
                if (this.redirect) {
                    window.location.href = this.redirect;
                }
            }
        },
        beforeCreate() {
            const self = this;
            axios.interceptors.response.use(
                response => response,
                error => {
                    if (error.response && error.response.status === 401) {
                        self.error = true
                        let error = 'Bejelentkezés szükséges';
                        if (error.response && error.response.data && error.response.data.errors) {
                            error = _.flatten(_.values(error.response.data.errors)).join('\n');
                        } else if (error.response && error.response.data && error.response.data.error) {
                            error = error.response.data.error
                        } else if (error.response && error.response.data && error.response.data.message) {
                            error = error.response.data.message
                        } else if (error.response && error.response.data && error.response.message) {
                            error = error.response.message
                        }
                        self.errorMessage = error;

                        this.redirect = '/user/login';
                        setTimeout(() => {
                            window.location.href = this.redirect;
                        }, 5000);
                        return;
                    }
                    if (error.response) {
                        if (error.response && error.response.data && error.response.data.errors) {
                            error = _.flatten(_.values(error.response.data.errors)).join('\n');
                        } else if (error.response && error.response.data && error.response.data.error) {
                            error = error.response.data.error
                        } else if (error.response && error.response.data && error.response.data.message) {
                            error = error.response.data.message
                        }
                        self.error = true
                        self.errorMessage = error
                    }
                    return error;
                });
        }
    }
</script>


<style lang='scss'>
    #visitor {
        .v-application--wrap {
            min-height: auto;
        }

        width: 100%;
    }
</style>
